import React from 'react';
import { Button } from 'antd';

/** Any of these lets a member open Worker mode (milk, feed given, sick / injured, report a problem). */
export const WORKER_MODE_PERMISSIONS = ['create animal yields', 'create animal feedings', 'create animal observations', 'create alerts'];

const digitsOnly =(value) => String(value ?? '').replace(/\D/g, '');

/** Animals whose tag is the typed/spoken value; "245" also matches tag "PK-245". */
export const findByTag = (animals, value) => {
  const typed = String(value ?? '').trim().toLowerCase();
  if (!typed) return [];
  const exact = animals.filter((a) => (a.tag_number || '').toLowerCase() === typed);
  if (exact.length) return exact;
  const digits = digitsOnly(typed);
  return digits ? animals.filter((a) => digitsOnly(a.tag_number) === digits) : [];
};

export const animalLabel = (a) => `${a.tag_number || `#${a.id}`}${a.name ? ` · ${a.name}` : ''}`;

export const BigButton = ({ style, ...props }) => (
  <Button size="large" block style={{ height: 64, fontSize: 20, fontWeight: 600, ...style }} {...props} />
);
